"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TextField = require("../TextField");

var _NumberFormat = _interopRequireDefault(require("../NumberFormat"));

var _excluded = ["integer", "name", "value", "onChange", "onBlur"];

/**
 * Text field for entering currency.
 * See [TextField](/#!/TextField) for props info.
 */
var NumericTextField = function NumericTextField(_ref) {
  var integer = _ref.integer,
      name = _ref.name,
      value = _ref.value,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_NumberFormat["default"], (0, _extends2["default"])({
    decimalScale: integer ? 0 : undefined
  }, props, {
    name: name,
    value: value,
    onChange: onChange,
    onBlur: onBlur
  }));
};

NumericTextField.propTypes = (0, _extends2["default"])({}, _TextField.TextFieldProps, {
  integer: _propTypes["default"].bool,
  value: _propTypes["default"].number
});
NumericTextField.defaultProps = {
  integer: false
};
var _default = NumericTextField;
exports["default"] = _default;